import adminhomeHtml from './presentation/routes/admin/admin-home.html';
import adminusersHtml from './presentation/routes/admin/admin-users.html';
import adminGroupsHtml from './presentation/routes/admin/groups/angular/groups-admin.html';
import contract3d from './presentation/routes/contract-3d/contract-3d.html';
import contractassociationHtml from './presentation/routes/contract-associations2/contract-associations.html';
import contracteventlogHtml from './presentation/routes/contract-eventlog/angular/contract-eventlog.html';
import contractDownloadHtml from './presentation/routes/contract-download/angular/download.html';
import contractexportHtml from './presentation/routes/contract-export/contract-export.html';
import contractfeatures3Html from './presentation/routes/contract-features-3/angular/contract-features.html';
import contractfilesHtml from './presentation/routes/contract-files/contract-files.html';
import contracthomeHtml from './presentation/routes/contract-home/contract-home.html';
import contractsettingsHtml from './presentation/routes/contract-settings/contract-settings.html';
import contractstatusHtml from './presentation/routes/contract-status/contract-status.html';
import contractlist2Html from './presentation/routes/contractlist-2/angular/contractlist-2.html';
import contractlocational2Html from './presentation/routes/contract-locational-2/angular/locational-2.html';
import newcontractHtml from './presentation/routes/newcontract/newcontract.html';
import loginHelpHtml from './presentation/routes/user-2/angular/login-help.html.html';
import changelogHtml from './presentation/routes/changelog/angular/changelog.html';
import dummyHtml from './presentation/routes/user/dummy.html';

interface RouteWithActiveTab extends angular.route.IRoute {
    activeTab: string;
}

export default function routes($routeProvider: angular.route.IRouteProvider) {
    $routeProvider.
        when('/contract', {
            template: contractlist2Html,
            activeTab : 'contractlist2'
        } as RouteWithActiveTab).
        when('/contract/:contractId', {
            template: contracthomeHtml,
            controller: 'ContractHomeController',
            controllerAs: 'conCtrl',
            activeTab : 'home'
        } as RouteWithActiveTab).
        when('/contract/:contractId/3d', {
            template: contract3d,
            activeTab : '3d'
        } as RouteWithActiveTab).
        when('/contract/:contractId/files', {
            template: contractfilesHtml,
            controller: 'ContractFilesController',
            controllerAs: 'conCtrl',
            activeTab : 'files'
        } as RouteWithActiveTab).
        when('/contract/:contractId/features3', {
            template: contractfeatures3Html,
            activeTab : 'features3'
        } as RouteWithActiveTab).

        when('/contract/:contractId/settings', {
            template: contractsettingsHtml,
            controller: 'ContractSettingsController',
            controllerAs: 'conCtrl',
            activeTab : 'settings'
        } as RouteWithActiveTab).
        when('/contract/:contractId/events', {
            template: contracteventlogHtml,
            activeTab : 'eventlog'
        } as RouteWithActiveTab).
            when('/contract/:contractId/locational2', {
            template: contractlocational2Html,
            activeTab : 'locational2'
        } as RouteWithActiveTab).
        when('/contract/:contractId/association', {
            template: contractassociationHtml,
            activeTab : 'associations'
        } as RouteWithActiveTab).
        when('/contract/:contractId/export', {
            template: contractexportHtml,
            controller: 'ContractExportController',
            controllerAs: 'conCtrl',
            activeTab : 'export'
        } as RouteWithActiveTab).
        when('/contract/:contractId/download', {
            template: contractDownloadHtml,
            activeTab : 'download'
        } as RouteWithActiveTab).
        when('/newcontract/:contractId?', {
            template: newcontractHtml,
            controller: 'NewContractController',
            controllerAs: 'newProjCtrl',
            activeTab : 'newContract'
        } as RouteWithActiveTab).
        when('/contract/:contractId/status', {
            template: contractstatusHtml,
            controller: 'ContractStatusController',
            controllerAs: 'statusCtrl',
            activeTab : 'status'
        } as RouteWithActiveTab).
        when('/contractstatus/:contractId', {
            template: contractstatusHtml,
            controller: 'ViewContractStatusController',
            controllerAs: 'statusCtrl',
            activeTab : 'status'
        } as RouteWithActiveTab).
        when('/projectstatus/:contractId', {
            template: contractstatusHtml,
            controller: 'ViewContractStatusController',
            controllerAs: 'statusCtrl',
            activeTab : 'status'
        } as RouteWithActiveTab).
        when('/user/resetpassword', {
            template: dummyHtml,
            controller: 'PreRequestResetUserPasswordController',
            controllerAs: 'resetPWCtrl',
            activeTab : 'resetpassword'
        } as RouteWithActiveTab).
        when('/user/login-help', {
            template: loginHelpHtml,
            activeTab : 'loginHelp'
        } as RouteWithActiveTab).
        when('/user/:username/verify/:token', {
            template: dummyHtml,
            controller: 'PreVerifyUserController',
            controllerAs: 'verifyUserCtrl',
            activeTab : 'verifyUser'
        } as RouteWithActiveTab).
        when('/user/:username/systemverify/:token', {
            template: dummyHtml,
            controller: 'PreVerifySystemUserController',
            controllerAs: 'verifyUserCtrl',
            activeTab : 'verifyuser'
        } as RouteWithActiveTab).
        when('/user/:username/resetpw/:token', {
            template: dummyHtml,
            controller: 'PreResetUserPasswordController',
            controllerAs: 'resetPWCtrl',
            activeTab : 'resetpassword'
        } as RouteWithActiveTab).
        when('/admin/home', {
            template: adminhomeHtml,
            controller: 'AdminController',
            controllerAs: 'admCtrl',
            activeTab: 'home'
        } as RouteWithActiveTab)
        .when('/admin/users', {
            template: adminusersHtml,
            controller: 'AdminController',
            controllerAs: 'admCtrl',
            activeTab: 'users'
        } as RouteWithActiveTab)
        .when('/admin/groups', {
            template: adminGroupsHtml,
            activeTab: 'groups'
        } as RouteWithActiveTab)
        .when('/admin', {
            redirectTo: '/admin/home'
        })
        .when('/changelog', {
            template: changelogHtml,
            activeTab : 'changeLog'
        } as RouteWithActiveTab)
        .otherwise({
            redirectTo: '/contract'
        });
}

routes.$inject = ['$routeProvider'];
